import React from "react";

const Details = () => {
  return <h1>This is the details page</h1>;
};

export default Details;
